import { InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './HoursInput.styles';

type Props = {
  value?: number;
  onChange?: (value?: number) => void;
};

export const HoursInput: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation('CommonQuizFormTranslations');

  return (
    <Wrapper>
      <div>{t('HOURS')}</div>
      <InputNumber
        min={0}
        max={24}
        value={value}
        onChange={number => onChange?.(number ?? undefined)}
      />
    </Wrapper>
  );
};
